import * as React from 'react';

import type { FeedItemType } from '@/types';

import { useFetchReadDeeplinks } from './useFetchReadDeeplinks';

export const useGetFeedCardStatus = (result: FeedItemType) => {
  const { isLoading, deeplinks, isError } = useFetchReadDeeplinks();
  const readStatus = React.useMemo(() => {
    if (deeplinks) {
      return deeplinks.includes(result.deeplink);
    }
    return false;
  }, [deeplinks, result.deeplink]);

  return { isLoading, readStatus, isError };
};
